import React from 'react';
import UploadComponent from '@cp/src/components/UploadComponent/UploadComponent';
import { CustomFileUploadComponent } from '@cp/src/pages/Enach/Components/CustomFileUploadComponent';
import { FileUploadContainerProps } from '../../pages/AllocationServices/BulkUpload/interfaces';
import UploadedFileStates from './FileUploadStates';

const FileUploadContainer: React.FC<FileUploadContainerProps> = ({
  error,
  file,
  setFile,
  setError,
  showLoadingComponent,
  setShowLoadingComponent,
  handleDownloadClick,
  styles
}) => {
  return (
    <>
      <UploadComponent
        setFile={setFile}
        file={file}
        uploadContentContainer={CustomFileUploadComponent}
        containerClassName={styles.subContainer}
        supportedFile=".csv"
        setHasError={setError}
        MAX_FILE_SIZE_IN_MB={5}
        isSampleFileAvailable={true}
        onSampleFileDownload={handleDownloadClick}
        customClassName={styles.text2}
        disabled={showLoadingComponent}
        textClassnameContainer="mt-5 mb-1 text-[var(--grayscale-3)]"
      />
      <UploadedFileStates
        error={error}
        file={file}
        setFile={setFile}
        setError={setError}
        showLoadingComponent={showLoadingComponent}
        setShowLoadingComponent={setShowLoadingComponent}
      />
    </>
  );
};

export default FileUploadContainer;
